import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { TranslocoRootModule } from './transloco-root.module'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgxChartsModule } from '@swimlane/ngx-charts'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import { NetworkBlockModalComponent } from './_components/modals/network-block-modal/network-block-modal.component'

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    TranslocoRootModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    NetworkBlockModalComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {
  constructor() {
    ModuleRegistry.registerModules([AllCommunityModule])
  }
}
